import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { OutputDescriptionProcessingStatesType } from '../schema/types';
import { OutputDataUrl } from './OutputDataUrl';
import { ISODate } from '../../common/utils';
import { OutputDescriptionProcessingStatesSchema } from '../schema/OutputDataSchema';

export interface OutputDescriptionProcessingStatesParams {
  groupId: number;
  valueDate: ISODate;
  frequencyId: number;
  selectAll?: boolean;
}

const getOutputDescriptionProcessingStates = (
  params?: OutputDescriptionProcessingStatesParams,
) =>
  apiClient
    .get<OutputDescriptionProcessingStatesType>(
      expand(OutputDataUrl.OUTPUT_DESCRIPTION_PROCESSING_STATES, params),
    )
    .then((response) =>
      OutputDescriptionProcessingStatesSchema.parse(response.data),
    );

export const useOutputDescriptionProcessingStatesQuery = createApiQueryHook(
  ['outputDescriptionProcessingStates'],
  getOutputDescriptionProcessingStates,
);
